import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { BenefitsSettingsModel } from '../../../../models/benefitsModels';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { getDateWithOffset, markFormGroupTouched, updateFormGroupValidity } from '../../../../helpers/utils';
import { closeEditBenefitsSettings, loadBenefitsSettings, saveBenefitsSettings, saveBenefitsSettingsSuccess } from '../../../../core/store/benefits/benefits.actions';

@Component({
    selector: 'app-edit-benefit-settings',
    templateUrl: './edit-benefit-settings.component.html',
    styleUrls: ['./edit-benefit-settings.component.scss'],
    standalone: false
})
export class EditBenefitSettingsComponent extends BaseComponent implements OnInit {
  display: boolean = false;
  title: string = "Edit Open Enrollment";
  form: UntypedFormGroup;
  disableButtons: boolean = true;
  

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private fb: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.form = this.createForm();
    this.subs.push(
      this.store.select(s => s.benefitsState.editingBenefitsSettings).subscribe(editing => {
        if (editing) {
          this.store.dispatch(loadBenefitsSettings());
        }
        this.display = editing;
      }),
      this.store.select(s => s.benefitsState.savingBenefitsSettings).subscribe(saving => {
        this.disableButtons = saving;
      }),
      this.store.select(s => s.benefitsState.benefitsSettings).subscribe(settings => {
        if (settings == null) {          
          return;
        }

        this.form.get("openEnrollmentStart").setValue(formatDate(settings.openEnrollmentStart, 'yyyy-MM-dd', 'en-us'));
        this.form.get("openEnrollmentEnd").setValue(formatDate(settings.openEnrollmentEnd, 'yyyy-MM-dd', 'en-us'));
        this.form.get("irsContributionLimit").setValue(settings.irsContributionLimit);
        this.form.get("familyYearlyContribution").setValue(settings.familyYearlyContribution);
        this.form.get("catchUpContribution").setValue(settings.catchUpContribution);
        this.form.get("catchUpContributionStartingAge").setValue(settings.catchUpContributionStartingAge);
      }),
      this.actions$.pipe(
        ofType(saveBenefitsSettingsSuccess),
        tap(action => {
          this.closeModal();
          //this.store.dispatch(loadBenefitsSettings()); //reload for other parts of system....is this needed?
        })
      ).subscribe()
    );    
  }

  createForm() {
    let f = this.fb.group({
      openEnrollmentStart: this.fb.control(formatDate(getDateWithOffset(0), 'yyyy-MM-dd', 'en-US'), [Validators.required]),
      openEnrollmentEnd: this.fb.control(formatDate(getDateWithOffset(14), 'yyyy-MM-dd', 'en-US'), [Validators.required]),
      irsContributionLimit: this.fb.control(0),
      familyYearlyContribution: this.fb.control(0),
      catchUpContribution: this.fb.control(0),
      catchUpContributionStartingAge: this.fb.control(0),
    });

    return f;
  }

  closeModal() {
    this.store.dispatch(closeEditBenefitsSettings());
  }

  saveBenefitSettingsEdits() {
    updateFormGroupValidity(this.form);
    if (this.form.valid) {
      this.store.dispatch(saveBenefitsSettings({ benefitsSettings: this.form.value as BenefitsSettingsModel }));
    }
    else {
      markFormGroupTouched(this.form);
    }
  }

}
